import { Link, Outlet } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { SkipLink } from './SkipLink';
import { ThemeToggle } from './ThemeToggle';
import { useAuth } from '@/store/auth';
import { useT } from '@/i18n';
import { LanguagePicker } from './LanguagePicker';

export function MarketingLayout() {
  const user = useAuth((s) => s.user);
  const t = useT();
  const signedIn = Boolean(user && !user.isAnonymous);

  return (
    <div className="grain flex min-h-dvh flex-col bg-bg">
      <SkipLink />

      <header className="border-b border-hairline">
        <div className="mx-auto flex h-header max-w-content items-center px-4 sm:px-6">
          <Logo to="/" />
          <div className="ml-auto flex items-center gap-2">
            <LanguagePicker />
            <ThemeToggle />
            <Link
              to={signedIn ? '/app' : '/auth/sign-in'}
              className="rounded-sm px-3 py-2 text-[0.9375rem] text-muted transition-colors hover:text-ink"
            >
              {signedIn ? t('nav.myVideos') : t('nav.signIn')}
            </Link>
          </div>
        </div>
      </header>

      <main id="main" className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-hairline">
        {/* No copy-protection caveat here: this layout serves the public
            pages. Senders get it at sign-up and on every screen behind the
            login, where it informs what they are about to send. */}
        <div className="mx-auto flex max-w-content flex-col gap-3 px-4 py-8 text-sm text-muted sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <p>{t('brand.tagline')}</p>
          <Link to="/app/settings" className="underline underline-offset-2 hover:text-ink">
            {t('nav.privacy')}
          </Link>
        </div>
      </footer>
    </div>
  );
}
